import React, { useState } from 'react';

function overlayValueClass(pct) {
  if (pct >= 70) return 'overlay-value overlay-value-green';
  if (pct >= 40) return 'overlay-value overlay-value-amber';
  return 'overlay-value overlay-value-red';
}

export function TickOverlay({ entry, onConfirm, onCancel }) {
  const [conf, setConf] = useState(50);
  const [saving, setSaving] = useState(false);
  const sliderBg = `linear-gradient(to right, var(--blue) 0%, var(--blue) ${conf}%, var(--border) ${conf}%, var(--border) 100%)`;

  return (
    <div className="overlay-backdrop" onClick={!saving ? onCancel : undefined}>
      <div className="overlay-card" onClick={e => e.stopPropagation()}>
        <div className="overlay-name">{entry.subtopic}</div>
        {entry.subject_area && <div className="overlay-subject">{entry.subject_area}</div>}
        <div className="overlay-label">Confidence</div>
        <input
          type="range" min="0" max="100" step="5"
          value={conf}
          onChange={e => setConf(parseInt(e.target.value))}
          className="overlay-slider"
          style={{ background: sliderBg }}
        />
        <div className="overlay-range"><span>0</span><span>100</span></div>
        <div className={overlayValueClass(conf)}>{conf}%</div>
        <button
          className="btn-primary-full"
          disabled={saving}
          onClick={async () => { setSaving(true); await onConfirm(conf / 100); }}
          style={{ marginBottom: 8 }}
        >
          {saving ? 'Saving' : 'Done'}
        </button>
        <button className="btn-ghost-full" onClick={onCancel} disabled={saving}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default TickOverlay;
